"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentLine = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const react_number_format_1 = require("react-number-format");
const Payment_1 = require("../../../models/Payment");
const dateUtils = __importStar(require("../../../utils/dateUtils"));
const DayPickerCustomInput_1 = require("../../day-picker/DayPickerCustomInput");
const DeletePaymentAction_1 = require("../actions/DeletePaymentAction");
const PaymentLine = (props) => {
    function handlePaymentTypeChange(type) {
        const paymentClone = (0, cloneDeep_1.default)(props.payment);
        paymentClone.amount = -1 * paymentClone.amount;
        props.onPaymentChange(paymentClone);
    }
    function handlePaymentDateChange(date) {
        const paymentClone = (0, cloneDeep_1.default)(props.payment);
        paymentClone.date = date;
        props.onPaymentChange(paymentClone);
    }
    function handlePaymentAmountChange(amount) {
        const paymentClone = (0, cloneDeep_1.default)(props.payment);
        let validValue = amount ? amount : 0;
        validValue = Math.round(validValue * 100) / 100;
        validValue = Math.max(-1000000, Math.min(validValue, 1000000));
        paymentClone.amount = validValue;
        props.onPaymentChange(paymentClone);
    }
    const positiveAmount = props.payment.amount >= 0;
    const multiplicator = positiveAmount ? 1 : -1;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("td", { className: "d-flex" },
            react_1.default.createElement("select", { className: "payment-type", value: props.payment.getPaymentType(), onChange: (e) => handlePaymentTypeChange(e.target.value), disabled: !props.editable }, Payment_1.Payment.paymentTypes.map((type) => {
                return react_1.default.createElement("option", { key: type }, type);
            })),
            react_1.default.createElement(DayPickerCustomInput_1.DayPickerCustomInput, { className: "d-inline-block", date: props.payment.date, onDateChange: handlePaymentDateChange, todayButton: "Heute", editable: props.editable, minDate: dateUtils.defaultMinDate, maxDate: dateUtils.defaultMaxDate })),
        react_1.default.createElement("td", { className: "text-nowrap" },
            react_1.default.createElement("span", null, positiveAmount ? react_1.default.createElement(react_1.default.Fragment, null, "\u2013 ") : ""),
            react_1.default.createElement(react_number_format_1.NumericFormat, { className: "payment-amount d-inline-block", displayType: "input", thousandSeparator: "'", decimalSeparator: ".", placeholder: "Betrag", decimalScale: 2, fixedDecimalScale: true, onFocus: (e) => e.target.select(), value: multiplicator * props.payment.amount, onValueChange: (e) => { var _a; return handlePaymentAmountChange(multiplicator * ((_a = e.floatValue) !== null && _a !== void 0 ? _a : 0)); }, disabled: !props.editable })),
        react_1.default.createElement("td", null, props.editable && (react_1.default.createElement(DeletePaymentAction_1.DeletePaymentAction, { onDelete: props.onPaymentDelete })))));
};
exports.PaymentLine = PaymentLine;
